import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SingleFieldManager from "@com/SingleFieldManager.vue";
export default {
  __name: 'ServiceManager',

  setup(__props) {
    const config = {
      name: '餐饮服务',
      type: 'service',
      route: 'servicemanager'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SingleFieldManager, {
        config: config
      });
    };
  }

};